export const rbrPresets = {
	"ASHSTD": [1.49, 1.93, 2.39, 2.84, 3.29, 3.74],
	"ASHLOW": [1.69, 2.26, 2.83, 3.40, 3.97, 4.54],
	"CA": [1.37, 1.74, 2.57, 3.11, 4.23, 3.77],
	"CTCAC": [1, 1.5, 3, 4.5, 6, 7.5],
}

export const gpdppPresets = {
	ashLow: 20,
	ecoMark: 25,
	ashMed: 49,
}

export const brTypes = [
	{ label: 'Studio', numBRs: 0 },
	{ label: '1 Bedroom', numBRs: 1 },
	{ label: '2 Bedroom', numBRs: 2 },
	{ label: '3 Bedroom', numBRs: 3 },
	{ label: '4 Bedroom', numBRs: 4 },
	{ label: '5 Bedroom', numBRs: 5 },
]

export const rPeopleOpts = [
	{ value: 'user', label: 'User Defined' },
	{ value: 'ASHSTD', label: 'ASHRAE Market Rate' },
	{ value: 'ASHLOW', label: 'ASHRAE Low Income' },
	{ value: 'CA', label: 'California - RASS Data' },
	{ value: 'CTCAC', label: 'California Tax Credit Allocation Committee' },
]

export const gpdppOpts = [
	{ value: 'user', label: 'User Defined' },
	{ value: 'ashLow', label: 'ASHRAE Low' },
	{ value: 'ecoMark', label: 'Ecotope Market Rate with Low Flow Fixtures' },
	{ value: 'ashMed', label: 'ASHRAE Medium' },
	{ value: 'ca', label: 'California By Bedroom' },
]
